import React from 'react';

import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

import { SyncLoader } from 'halogenium';

import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const loaderStyle = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  background: 'white',
  zIndex: '10',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
export default class ChargeCardDialog extends React.Component {
  render() {
    const style = {
      table_header: {
        margin: '5px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
      },
    };

    return (
      <Dialog
        disableBackdropClick
        fullScreen={this.props.fullScreen}
        open={this.props.isOpen}
        aria-labelledby="charge-application-fee-dialog"
      >
        {this.props.submittingMonthlyDeposit && (
          <div style={loaderStyle}>
            <div className="col-xs-12" style={{ textAlign: 'center' }}>
              <SyncLoader color={AccentColor()} size="16px" margin="auto" />
              <div className="col-xs-12" style={{ marginTop: '10px' }}>
                <p style={{ textAlign: 'center' }}> Please wait as we process your payment </p>
              </div>
            </div>
          </div>
        )}
        {this.props.skippingMonthlyDeposit && (
          <div style={loaderStyle}>
            <div className="col-xs-12" style={{ textAlign: 'center' }}>
              <SyncLoader color={AccentColor()} size="16px" margin="auto" />
              <div className="col-xs-12" style={{ marginTop: '10px' }}>
                <p style={{ textAlign: 'center' }}>
                  {' '}
                  {getTranslatedString('landlordPortal.chargeCardDialog.pleaseWaitBypass')}{' '}
                </p>
              </div>
            </div>
          </div>
        )}

        <div style={{ height: '100%' }}>
          <DialogTitle id="payment-dialog">
            <h3 style={{ textAlign: 'center', margin: 0 }}>Charge Deposit</h3>
          </DialogTitle>

          <DialogContent>
            <div className="row" style={style.table_header}>
              <div style={{ textAlign: 'center' }}>
                <span style={{ textAlign: 'center' }}>CHARGE DEPOSIT</span>
              </div>
            </div>

            <div className="row">
              <p style={{ textAlign: 'center' }}>
                {' '}
                You must charge the applicant to continue. Click the button below to process the
                amount owing from the applicant&rsquo;s prefered payment method.
              </p>
            </div>
          </DialogContent>

          <div className="row" style={{ textAlign: 'center' }}>
            <FlatButton
              onClick={this.props.chargeCard}
              style={{
                color: 'white',
                backgroundColor: AccentColor(),
                padding: '0 15px',
              }}
            >
              COLLECT DEPOSIT
            </FlatButton>
          </div>
          <div className="row" style={{ textAlign: 'center', marginTop: '10px' }}>
            <h5 style={{ fontSize: '10px' }}>
              <button type="button" className="link-button" onClick={this.props.skipCharge}>
                {getTranslatedString('landlordPortal.chargeCardDialog.payADifferentWay')}
              </button>
            </h5>
          </div>
        </div>

        <DialogActions style={{ display: 'block' }}>
          <FlatButton
            onClick={this.props.toggleOpen}
            id="close-button"
            style={{ color: AccentColor() }}
          >
            CANCEL
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }
}
